import { parseTwoDigits, isPassed, getTodayStatus, getTimeformat } from './util';

export default class scheduleTableTpl {
    static getTpl(data = {}) {
        const dayOfWeekString = {1 : '월', 2: '화', 3: '수', 4: '목', 5: '금', 6: '토', 7: '일'};
        const weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map( (value, index) => {
            // today(오늘), selected(현재선택된) 요일 클래스 추가
            return `<li class="${index == (data.standardDate.dayOfWeek - 1) ? `today selected`: ``}"><span>${value}</span></li>`;
        } ).join('');

        console.log('#ScheduleTableTpl.js data : ', data);
        const url = window.location.href;
        return `
        <div class="schedule-header">
            <strong class="today">${data.currentDate.year}. ${parseTwoDigits(data.currentDate.month)}. ${parseTwoDigits(data.currentDate.day)}. (${dayOfWeekString[data.currentDate.dayOfWeek]})</strong>
            <div class="schedule-header-time">
                <em class="time">현재시간 ${parseTwoDigits(data.currentDate.hour)}:${parseTwoDigits(data.currentDate.minute)}</em>
                <a href="${url}" role="button" class="btn-reload"><span class="blind">새로고침</span></a>
            </div>
        </div>
        <div class="schedule-table">
            <div class="schedule-table-head">
                <ul class="schedule-table-row">
                    ${weekList}
                </ul>
            </div>
            <div class="schedule-table-body">
                ${Object.keys(data.objByTime).map(scheduleTableTpl.rowItem, {data: data}).join('')}
            </div>
        </div>`;
    }

    static rowItem(key = 0, index = 0) {
        // row 데이터 (월~일)
        const parseData = {
            standardDate: this.data.standardDate,
            currentDate: this.data.currentDate,
            objByTime: this.data.objByTime[key]
        };
        return `
        <ul class="schedule-table-row">
            ${Object.keys(parseData.objByTime).map(scheduleTableTpl.colItem, {parseData: parseData}).join('')}
        </ul>`;
    }

    static colItem(key = 0 , index = 0) {
        // 해당 row 의 한 column (ex. item = 월요일, 시작시간이 10시인 일정)
        const item = this.parseData.objByTime[key];

        return `
        <li class="schedule-table-col">
            ${item.map(scheduleTableTpl.itemInner, {
                parseData: this.parseData,
                key: key
            }).join('')}
        </li>`;
    }

    static itemInner(data = {}) {
        // 하나의 일정 내부
        let status = ``,
            label = ``;
        
        // 현재 요일인 경우
        if(this.key == this.parseData.standardDate.dayOfWeek) { 
            const currentTime = `${this.parseData.currentDate.hour}:${this.parseData.currentDate.minute}`;
            // status = isPassed(data.endTime, currentTime) ? `disabled` : isPassed(data.startTime, currentTime) ? `now` : ``;
            status = getTodayStatus(data.startTime, data.endTime, currentTime);
        }

        // 딱지 종류별 DOM
        switch(data.label) {
            case `hot`: 
                label = `<em class="hot-tag"><span class="blind">HOT</span></em>`;
                break;
            case `new`:
                label = `<em class="new-tag"><span class="blind">NEW</span></em>`;
                break;
            default:
                label = ``;
        }
        
        return `
        <a href="${data.link ? data.link : `#`}" class="schedule-element type-${data.category} ${status}">
            <strong class="schedule-title">${data.name}</strong>
            <em class="schedule-time">${getTimeformat(data.startTime)} - ${getTimeformat(data.endTime)}</em>
            ${label}
        </a>`;
    }
}


// WEBPACK FOOTER //
// ./_src/js/schedule/ScheduleTableTpl.js